import { render, staticRenderFns } from "./InformeGlobalNoConformidades.vue?vue&type=template&id=7f2c185a&"
import script from "./InformeGlobalNoConformidades.vue?vue&type=script&lang=js&"
export * from "./InformeGlobalNoConformidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports